import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'
import { PageTitle, Slideshow } from '../../components'
import s1 from './assets/s.1.jpg'
import s2 from './assets/s.2.jpg'
import s3 from './assets/s.3.jpg'
const slideShowData = [s1, s2, s3].map(function(slide, index){
    return {image: slide, text: "ВТОРА ХАРИТОНОВА ПРЕПРАВКА | НА „ИСТОРИЯ СЛАВЯНОБЪЛГАРСКА“ (ЧИРПАН, 1831)"}
})
const HaritonovaPrepravka2View = () => {
    return (
        <MainLayout>
            <Slideshow id="vtora-haritonova-prepravka" slides={slideShowData} />
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <p>
                        <strong>Название на ръкописа</strong>: Втора Харитонова преправка на „История славянобългарска" (Чирпан, 1831)
                    </p>
                    <p>
                        <strong>Година на съставяне: </strong>1831 г.
                    </p>
                    <p>
                        <strong>Място на преписване</strong>: Чирпан, Старозагорско
                    </p>
                    <p>
                        <strong>Преписвач(и</strong>): йеромонах хаджи Харитон Рилец и трима негови ученици
                    </p>
                    <p>
                        <strong>Палеографско-кодикологично описание.</strong> Втората Харитонова преправка на „История славянобългарска"
                        (Чирпан, 1831) е без автентично заглавие. Видимите ѝ белези я представят като самостоятелно ръкописно книжно тяло,
                        обгърнато с картонени корици, които са обвити в червеникава кожа. Обложката е украсена с венец от единични цветя,
                        рамкиращи и отварящата, и затварящата корица. В ъглите и по средата са струпани цветни фигури, заплетени в
                        плетеници. И макар че времето е „отхапало" парченца от ъгълчетата на кориците, наранявайки ги съществено,
                        оригиналът е достигнал до нас добре съхранен,<em> </em>с изцяло опазено съдържание. Във вътрешността на ръкописа се
                        открива една празна страница (л. 33б), която е оставена такава, защото е попила от мастилото на предходната
                        страница. „Историята" на цар Долан, прекъсната заради същата празна страница, е продължена на следващата, без да се
                        нарушава целостта на съдържанието ѝ (л. 33а – 34а). Историческото съдържание на ръкописа, извън листовете, върху
                        които са положени бележките и приписките, се простира върху 77 страници. Писано е и от двете страни, по протежение
                        на всеки лист. Шестдесет и осем листа са с оригинална буквена пагинация. В горния десен ъгъл на част от листовете
                        (post factum) с молив е добавено и означение с арабски цифри. Неизписани са първият и последният от листовете на
                        Втората Харитонова преправка.
                    </p>
                    <p>
                        <strong>Писмо на ръкописа: </strong>Едър некалиграфски полуустав, който на места се редува със среден полуустав.
                        Различията се обуславят от почерците на четирима различни преписвачи – освен от Харитон, ръкописът е списван и от
                        други ръце (Караджова 2012).
                    </p>
                    <p>
                        <strong>Хартията</strong>, върху която са писали преписвачите, е груба и грапава, с хоризонтално линиране. Оцветена
                        е в бледорозово със зеленикави ивици, вплетени в листовете. Листовете са с воден знак – герб с корона, с размери 20
                        х 24 см. (Стоянов 1962: 577).
                    </p>
                    <p>
                        <strong>Украса: </strong>Втората Харитонова преправка няма винетни изображения, украсяват я заглавията с киновар,
                        които в повечето случаи, са добре подчертани и поради изписването им с червено мастило, и поради отразяването им с
                        главни букви. Пак с червенослов са откроени и първите главни букви, отделящи абзаците, но и тази практика не е
                        последователна. С киноварно маркиране са и всички години, които в целия ръкопис имат единствено буквени
                        обозначения.
                    </p>
                    <p>
                        Палеографските особености на Втора Харитонова преправка са проучени най-пълно от Маньо Стоянов (Стоянов 1962: 577 –
                        578) и Б. Ангелов (1966: 56 – 57).
                    </p>
                    <p>
                        <strong>Поръчител(и) на ръкописа: </strong>Не е известно дали ръкописът е бил поръчан от някого, или е изготвен за
                        даскалските потреби на самия монах Харитон.
                    </p>
                    <p>
                        <strong>Извод (подложка, антиграф), от който пряко се преписва:</strong> Първата Харитонова преправка на „История
                        славянобългарска" (Змеево, 1831).
                    </p>
                    <h2>Родослов:</h2>
                    <p>
                        Автографът на Харитон от 1831 г., който е изработен в Чирпан, принадлежи на родословното
                        дърво на Рилската преправка (Рилски манастир, 1825). Рилската преправка е протограф (матрица, първоизвор) на три
                        родословни разклонения (Тодоров 1985, 196 – 198). Интересуващият ни пряк родослов на Втора Харитонова преправка,
                        който възхожда към Рилската преправка, може да се разгърне със схемата:
                    </p>



                    <p>
                        Рилската преправка (Рилски манастир, 1825) → Поп-Йоанова преправка (Змеево, 1830, поп Йоаникия Петкович) →
                    Първа Харитонова преправка (Змеево, 1831, йеромонах Харитон Рилец) → <strong>Втора Харитонова преправка
                        (Чирпан, 1831, йеромонах Харитон Рилец) </strong>→ Геров препис (ок. 1851 – 1853, Пловдив, Найден Геров).
                    <strong>//</strong> <strong>Втора Харитонова преправка</strong> → работен препис (частичен) на Владимир
                    Ламански (Цариград, 1864) <strong>//</strong> <strong>Втора Харитонова преправка</strong> → Трета Харитонова
                    преправка (1832, неизвестно къде е преписана).
                    </p>
                    <p>
                        Видно е, че Втора Харитонова преправка се ползва за извод от следващи ръкописи, което означава, че те
                        възхождат пряко към Харитоновия автограф, но имат непреки връзки с протографа Рилската преправка.
                    </p>
                    <p>
                        Повечето от гореописаните ръкописи са достигнали до нас. Има обаче и изгубен оригинален ръкопис от същия
                        родослов, който условно представям като Трета Харитонова преправка на „История славянобългарска". Известно
                        е, че той е съставен през 1832 г., а мястото на съставянето му не е неуточнено. За ръкописа се съобщава в
                        „Църковен вестник" от 1912 г. Без да изписва името си, авторът на статията твърди:
                    </p>
                    <p>
                        „Пишещият тия редове има пред себе си и 9-и препис. Този препис е снет от Харитон монах в 1832 г. месец
                        януарий 10-и день. От този препис са заети статията „<em>Болгарская земля</em>" и <em>„Кратка исторiя
                            заради болгарския род</em>"<em>, </em>които са поместени на друго място в днешния брой на „Ц. в." „Не
                        се знае само мястото, дето е снеман преписа. Никъде в целия ръкопис не се намира бележка за мястото дето е
                        живял преписвача, когато е снемал преписа. Преписът е подвързан и запазен добре. Само в средата се скъсани
                        четири листа, именно листовете 79, 80, 81 и 82, дето се разправя за Св. Кирил и Методий и покръщението на
                        българите" (Анонимен автор 1912, 240, курсивът е на автора, цитатът е адаптиран според съвременното
                        графично изписване на думите, но са запазени авторовият правопис и пунктуация – бел. М. Кр.).
                    </p>
                    <p>
                        Днес в научната литература се водят дискусии по повод реалното съществуване на Трета Харитонова преправка,
                        а сред изследователите, застъпващи различни хипотези, се нареждат имената на И. Тодоров (1985, 196 – 197),
                        Д. Караджова (2012, 239 – 240), М. Кръстева (2015, 45- 51) и др.
                    </p>
                    <p>
                        В родослова е имало и друг ръкопис – частично работно копие, изготвено от Вл. Ламански. За извод му служи
                        Харитоновата преправка от Чирпан. Днес мястото на работното копие, за чиято наличност съобщава самият руски
                        учен (Ламанский 1869, 107), не е издирено, вероятно се намира в ръкописния архив на руския учен.
                    </p>

                    <h2>Бележките във Втора Харитонова преправка: </h2>
                    <ul>
                        <li>
                            Върху гърба на предната корица: „Да се знае кога е изгорял Калофер. За първи път през 1793. Гергьовден
                            е бил в събота преди Великден; после пак след 11 години, през 1804 година: Гергьовден е бил в събота
                            преди Великден; в 1850 година: Гергьовден и Великден бяха едновременно". (Преводът на съвременен
                            български език е на Антоанета Джельова).</li>
                        <li>Л. 78а: „Да бъде известно, че с усърдието и спомоществованието на монах Харитон, в година 7339 от
                                сътворението на света, в година 1831 от Христовото въплъщение, когато аз живеех в град Чирпан и когато
                                учех децата да четат книги, се преписа тази история от трима писари, освен четиринадесетте листа. От
                                Адама 386 кръга, кръг на луната 5, основание 28, законна Пасха април 18, Пасха Христова април 19,
                                Петрова 2 неделя. Пасхална литера ъ." (Преводът на съвременен български език е на Антоанета Джельова).</li>
                        <li>Върху празния л. 80а: „За войнството на фараона, който изгони Израиля: 200 000 пешаци, 50 000 конници,
                                8000 колесници". Върху вътрешната страна на задната корица: „Неистово, казва Премъдрият Соломон,
                                Беззаконие ще опустоши цялата земя, както е опустошило и по времето на преподобния Ной, и Злодейство ще
                                преобърне престолите на Силните. Ако не би било това Беззаконие и Злодейството не би паднала България и
                                не биха се срутили троновете на кралете и на нейните царе. Виждаш ли Беззаконието и Злодейството какво
                                са направили, камък на камък не е останал. Виждайки Търново, написах това". (Преводът на съвременен
                                български език е на Антоанета Джельова).</li>
                    </ul>


                    <h2>Приписки в ръкописа, оставени от други ръце (на вероятни читатели или притежатели на оригинала): </h2>
                    <ul>
                        <li>Върху гърба на предната корица: „Богданов Божиробов Божий раб Басарабия". (Преводът на съвременен български език е на Антоанета Джельова).</li>
                        <li>На гърба на предната корица, под други две приписки: „Приел от Панайот П. Кръстев" (преводът е на Антоанета Джельова). Началото на приписката не се чете ясно, добре се различава само името Кръстев. Мастилото, с което е изписана приписката, е различно от мастилото на приписката над нея.</li>
                        <li>На гърба на предната корица, под гореописаната приписка: нечетливи подписи на ползватели на ръкописа, може би са изписани и изречения, които също не се разчитат.</li>
                        <li>Върху вътрешната страна на задната корица: „Летопис български за българските племена, който чете, с внимание да чете, да узнае какво царство са имали българите". (Преводът на съвременен български език е на Антоанета Джельова).</li>
                    </ul>

                    <p>
                        Руският професор Владимир Ламански, който добре познава Втората Харитонова преправка и пръв
                        публикува академична студия, посветена на палеографските ѝ особености (Ламанский 1869, 108
                        – 109), не публикува приписките, не дава информация и за наличието на подписите под нея.
                        Допускам, че причината се крие във факта, че приписката и подписите са добавени след 1869
                        г. Нито едно от изследванията, които познавам, не съобщава изнесената тук информация.
                    </p>
                    <h2>„География" на пътешествията на Втора Харитонова преправка: </h2>

                    <h3>Чирпан, 1831 – неизвестно докога е съхраняван на това място.
                    </h3>
                    <p>
                        Тук е завършен автографът на Харитон, самият той документира този факт в бележка на л. 78а. Чирпан, като
                        място на
                        памет за Харитон и втората му преправка, е споменат и от чирпанския даскал Таньо Пеев:
                    </p>
                    <p>
                        <strong>„Отец Харитон.</strong> (…) Презъ 1831 г. дошел в гр. Чирпан на съща длъжност [изповедник – бел. М.
                        Кр.],
                        гдето съградил Рилския метох, в който открил училище да подготвя учени граждани, уреждал в параклиса
                        сборове, в
                        които държал религиозно-нравствени проповеди, будил у гражданите народно чувство, като им чел пасажи от
                        Паисиевата
                        история. При това той снел нов препис на тая история, който препис учените сега наричат <em>„Чирпанска
                            преправка"</em>.
                    </p>
                    <p>
                        „Любознателността да изуча прибавките и притурките [на Втората Харитонова преправка – бел. М. Кр.], от една
                        страна,
                        когато едно време баща ми в битността си на църковен епитроп я е донасял у дома да я чете, и аз съм се
                        мъчел да
                        дешифрирам някои думи от нея, а той ми е казвал, че много хляб има да ям, докато се науча да разбирам <em>Царственика</em>
                        – така наричаха тогава тоя ръкопис – будеха у мене желанието да се снабдя с тая ръкописна история, да я
                        препиша и
                        предам в дружествената чирпанска библиотека на съхранение, както едно време оригиналът се е съхранявал в
                        черковния
                        ковчег, а после в читалищната библиотека, от гдето никой не е узнал до сега, как е липсвал от там и минал в
                        ръцете
                        на покойния Найден Геров" (Събчев, Пеев 1908: 311; 315 – 316.
                    </p>

                    <h3>Цариград, 1864 г.</h3>
                    <p>
                        Ръкописът, който по това време е притежание на Найден Геров, е отнесен от последния в Цариград, за
                        да бъде
                        даден на проф. Владимир Ламански. Достоверността на това свидетелство се потвърждава от самия
                        Ламански:
                    </p>
                    <p>
                        „Сега възнамерявам да обърна вниманието на читателя към друг по-нов Български сборник от XVIII век,
                        който
                        принадлежи на руския консул във Филипопол Н. Г. Геров, известен с литературните си трудове и в
                        руската
                        литература... Аз преписах този ръкопис още през лятото на 1864 г., по време на престоя си в
                        Цариград
                        (Ламанский 1869: 107, преводът от руски език е мой – М. Кр.). Ламански отнася работния си препис в
                        Русия.
                    </p>
                    <h3>Бесарабия</h3>
                    <p>
                        Съществува вероятност Втора Харитонова преправка де е била отнесена и в Бесарабия. За
                        подобна
                        възможност свидетелства приписка, положена върху гърба на началната корица на книгата, в
                        която
                        името Богдан се обвързва с Бесарабия (сравн. с приписката в оригиналния ръкопис: „Богданов
                        Божиробов Божий раб Басарабия").
                    </p>



                    <h3>Пловдив, Санкт-Петербург (Русия) </h3>
                    <p>
                        Както вече стана дума, оригиналът на Харитоновата книга, списана в Чирпан, дълго
                        време е
                        бил притежание на Найден Геров. Този факт се знае от съвременници на Геров като Вл.
                        Ламански, М. Дринов, Н. Начов, Ал. Т. Балан и др. и се цитира в научните им
                        изследвания,
                        посветени на ръкописа. Фактът, че Геров е притежавал ръкописа, се потвърждава и от
                        други
                        запазени документи. Такъв например е споменът на Таньо Пеев, част от който бе
                        цитирана
                        по-горе. Ето и продължението на спомена:
                    </p>
                    <p>
                        „Преди няколко години замолих Геровите наследници да ми поверят тоя ръкопис за
                        малко време,
                        като им изложих и целта, за която го искам, те, обаче, ми отговориха, че
                        библиотеката на
                        Герова била завещана на внука му Панчев, за да я подреди и напечата
                        кореспонденцията му.
                        След смъртта на Панчев един от синовете му излязал непрокопсаник, та разпродал на
                        ока по
                        бакали и касапи книжата на Найден Геровата архива и по такъв начин – и
                        прахосничество се
                        изгубиха следите на една така скъпа старина, преписвачът, на която светият о.
                        Харитон –
                        цели 15 години е проповядвал нейното учение в Чирпан и околията"<strong> (Събчев,
                            Пеев
                            1938:</strong> 311; 315 – 316; цитатът е адаптиран според съвременното графично
                        изписване на думите, но са запазени авторовият правопис и пунктуация – бел. М.
                        Кр.).
                    </p>
                    <p>
                        През 2012 г. в ръкописния архив на Н. Геров открих непубликувано към онова време
                        писмо,
                        което отново доказва, че Втора Харитонова преправка е била притежание на Геров и
                        родствениците му. Изнесените в писмото данни се нуждаят от коментар, затова го
                        цитираме
                        цялостно:
                    </p>
                    <blockquote>
                    <p>
                        „Юбилеен комитет за отпразнуване 75-годишнината на българската просвета в гр.
                        Чирпан (№ 8)
                    </p>
                    <p>
                        22 Октомвриий 1926 год.
                    </p>
                    <p>
                        Гр. Чирпан
                    </p>
                    <p>
                        До Г. Г. Наследниците на Найден Геров
                    </p>
                    <p>
                        от София
                    </p>
                    <p>
                        Почитаеми Господа,
                    </p>
                    <p>
                        В желанието си да съберем, ако не всичко, поне колкото се може повече от ония
                        документи и
                        данни, свидетели за политическото и културното възраждане на града ни, се
                        натъкнахме на
                        един безспорен факт, какво един екземпляр от Паисиевата история, известен под
                        название
                        „Чирпански ръкопис", се намира у Вас, останал от покойния Ви наследодател, Г-н
                        Найден
                        Геров. Тоя ръкопис е предаден на покойния за запазване тогава, когато Чирпанското
                        читалище
                        е било затворено от Турските власти в размирните години след залавянето на В.
                        Левски и
                        подвъргната на екзекуция всичката му литература.
                    </p>
                    <p>
                        За нас тоя ръкопис е ценен: 1) че той е бил притежание на читалището и 2) че в него
                        има
                        добавки според проф. Ламански, които липсуват у другите, а нашето желание е той да
                        бъде
                        издаден с всичките му добавки в сбирката, която приготовляваме по случай
                        100-годишнината на
                        първите наши училища и 75 год. от откриването на първото обществено училище.
                    </p>
                    <p>
                        Няма съмнение, че след като си послужим с ръкописа, ще ви го повърнем веднага.
                    </p>
                    <p>
                        Приемете Г. Г. уверенията ни в голямата ни почит към Вас." (Следва подпис, който не
                        се
                        чете; цитатът е адаптиран според съвременното графично изписване на думите, но са
                        запазени
                        авторовият правопис и пунктуация – бел. М. Кр.)
                    </p>
                    </blockquote>
                    <p>
                        Днес писмото е в ръкописния архив на Геров (БИА, НБКМ, ф. № 22, Найден Геров, оп.
                        І, а. е.
                        704, л. 82).
                    </p>
                    <p>
                        В цитираното писмо се твърди, че Втората Харитонова преправка е попаднала у Геров
                        след
                        залавянето на Левски. Знайно е, че Апостолът е заловен през декември 1872 г.
                        (Унджиев 1987,
                        4, 223 – 225), което ще рече, че ръкописът е попаднал у Геров след 1872 г. Тази
                        информация
                        обаче не може да е достоверна, защото, ако беше, то тогава нито Ламански, който
                        публикува
                        статия в Русия (1869 г.), посветена на особеностите на Втора Харитонова преправка,
                        нито
                        Дринов, чиято статия, тълкуваща същия ръкопис, излязла в България през 1871 г.,
                        щяха да
                        знаят, че Геров вече притежава Харитоновия втори препис на Паисиевата книга.
                        По-достоверно
                        звучи твърдението на Таньо Пеев, че не се знае кога и как Втора Харитонова
                        преправка става
                        притежание на Геров.
                    </p>
                    <p>
                        Тъй като Найден Геров задълго е притежавал оригинала на Харитоновата преправка от
                        Чирпан,
                        допускам, че е възможно книгата да го е съпътствала в битието му на книжовник,
                        даскал,
                        лексикограф, политик, дипломат... през дългия му престой в Пловдив, а сетне и в
                        „бягството"
                        му в Русия (Санкт Петербург), където се озовава по време на Кримската война.
                    </p>



                    <h3>София</h3>
                    <p>
                        Днес ръкописът<strong> </strong>е ценност, която се съхранява в столицата
                        ни.
                        Липсват конкретни сведения кога точно е предаден на съхранение в НБКМ.
                    </p>
                    <p>
                        <strong>Въвеждане на ръкописа в науката</strong>. За съществуването на
                        ръкописа
                        пръв съобщава руският професор Владимир Иванович Ламански в студията си
                        „Болгарская
                        словесность XVIII века". Руският учен изследва ръкописа, като го съпоставя
                        и с
                        книги от славянската историография. Ламански цитира някои от приписките на
                        Харитон,
                        а също и значителни фрагменти от съдържанието на преправката (Ламанский
                        1869, 107 –
                        123). През 1871 г. Марин Дринов въвежда преправката в анализационното поле
                        и на
                        българската академична наука. Ученият се позовава и на личните си
                        наблюдения, и на
                        научните изводи на Ламански, когато тълкува съпоставително Харитоновия
                        текст с
                        познатите му по онова време преписи на Паисиевата книга. Студията на Марин
                        Дринов,
                        чиято „гореща" изследователска точка е Втората Харитонова преправка,
                        всъщност
                        поставя същинското начало на трайния интерес на българската академична
                        мисъл към
                        Паисий, неговата история, неговото време и учениците му. Така именно чрез
                        Втората
                        Харитонова преправка и академичния опит на Дринов възрожденските българи
                        узнават,
                        че историографията е задълбочено знание, което има конкретноисторически
                        поетапен
                        развой (Дринов 1871). Повишен интерес към Втората преправка на Харитон през
                        Възраждането проявява и Найден Геров. Дълго време оригиналът на ръкописа е
                        негово
                        лично притежание (НБКМ, ф. 22, Найден Геров, оп. I, а. е. 704, 82). Тази е
                        и
                        причината, поради която ръкописът често се представя и чрез Геровото име.
                        Самият
                        Геров преписва Втората Харитонова преправка като съставя следващия ръкопис,
                        съдържащ се в родослова на Рилската преправка, в разклонението ѝ, което
                        върви по
                        линията: Рилска преправка → Геров препис. Преписаният от Геров текст
                        работно се
                        назовава като Геров препис на „История славянобългарска" (НБКМ, ф. 22, а.
                        е. 622, 1
                        – 70). Системно Втората Харитонова преправка е изследвана от Мила Кръстева.
                        В
                        студията ѝ „Предай нататък!" (Кръстева 2013, 165 – 208) е направен
                        задълбочен
                        текстологичен анализ на общото и особеното във Втората Харитонова преправка
                        и
                        ръкописите, които ползва за извори. Авторката цитира неизвестни на науката
                        документи, тълкува неизследвани приписки от ръкописа и пресъздава
                        (психо)биографията на монаха Харитон Рилец. Палеографската атрибуция на
                        ръкописа на
                        Харитон от Чирпан е наблюдавана и от Даринка Караджова, която изгражда
                        хипотеза,
                        възпроизвеждаща начина на преподаване в килийното училище в Чирпан, където
                        Харитон
                        е обучавал своите ученици на калиграфския занаят (Караджова 2012: 32 – 41).
                    </p>
                    <p>
                        От въвеждането на автографа на Харитон от Чирпан в науката до днес
                        ръкописът се
                        назовава с многобройни работни заглавия. Сред тях са: „Геровской рукопись"
                        (Ламанский 1869, 107 – 108); „Геровъ ръкописъ" (Дринов 1871, 16); „Геровъ
                        ркп."
                        (Начов 1984: 513);
                    </p>
                    <p>
                        „Геровски преписъ" (Златарски 1899: 751); „Чирпанска преправка" (Иванов
                        1914: LVI);
                        „Чирпанска преработка" (Стоянов 1962: 577); „Чирпанска преправка" (Динеков
                        1963,
                        134); „Чирпанска (Геровска) преработка на монаха Харитон" (Кодов, Стоянов
                        1964-3:
                        450 – 541); „Харитонова преправка на „История славянобългарска" (втора –
                        Чирпан,
                        1831)" – така я назовава Б. Ангелов (Ангелов 1966: 56 – 61); „Геров препис"
                        (Тодоров 1985: 197); Втори Харитонов (Чирпански, Геров препис), така
                        ръкописът е
                        описан в „чек-листа" на Димитрова и Пеев (Димитрова, Пеев 2012: 61). Тези
                        наблюдения налагат извода за трайна научна безпринципност при условното
                        назоваване
                        на ръкописа, датираща още от първите изследвания, посветени на Харитоновия
                        ръкопис,
                        а и до последните. Онова, което от гледна точка на литературната теория би
                        трябвало
                        да е недопустимо при изработването на условно назоваване на един и същи
                        ръкопис,
                        може да се систематизира така: недопустимо е ръкописът да се описва веднъж
                        – чрез
                        името на съставителя му, втори път – чрез името на виден негов притежател;
                        недопустимо е да се равнопоставят термините <em>ръкопис,</em> <em>препис</em>
                        и <em>преправка</em>,
                        които са носители на различна текстологична информация; недопустимо е при
                        съставянето на условното заглавие да се използват всевъзможни препинателни
                        знаци
                        (тире, запетая, средни скоби); недопустимо е едно работно заглавие да се
                        съставя от
                        няколко изречения, които съдържат сблъскваща се информация; недопустимо е
                        един и
                        същи изследовател – без изрични уговорки – да назовава преправката по
                        различен
                        начин в различните си изследвания. Описаната теоретична „безпътица" обърква
                        дори
                        вещите специалисти паисиеведи, затова Кръстева предлага книгата <strong>да
                            се
                            назовава еднозначно с работното заглавие Втора Харитонова преправка на
                            „История
                            славянобългарска" (Чирпан, 1831). </strong>Изследователската логика е
                        следната:
                        определението <em>втора </em>обозначава реда на хронологичната поява на
                        преправката
                        сред трите преправки, изготвени от Харитон; присъствието на Харитоновото
                        име
                        приемам за задължително поради наличието на автобиографична приписка в
                        ръкописа,
                        която документира, че преправката е Харитонов автограф; назоваването на
                        ръкописа с
                        термина <em>преправка </em>го определя като сюжетна редакция на „История
                        славянобългарска", преправяща всички ползвани извори, в това число и прекия
                        извод
                        (Първа Харитонова преправка), от който се различава съществено; изписването
                        на
                        „История славянобългарска" в условния заглавен апарат следва вече
                        утвърдената в
                        академичната литература традиция да представяме възрожденските преписи и
                        преправки,
                        позоваващи се на Паисиевата книга, именно по този начин. Приемам, че
                        вписването на
                        заглавието на Паисиевата книга е важен детайл на работното назоваване на
                        всички
                        възрожденски преписи и преправки, в частност и на Втора Харитонова
                        преправка,
                        защото именно Паисиевата история е свръхархетипът, от който поема пътя си
                        цялата
                        ръкописна преписваческа практика, отнасяща се до „История
                        славянобългарска".
                    </p>
                    <p>
                        <strong>Място на съхранение. </strong>Днес оригиналният ръкопис на Втора
                        Харитонова
                        преправка се съхранява в ръкописния отдел на Народната библиотека „Св.
                        Кирил и
                        Методий", каталогизиран под № НБКМ 1114 (Стоянов, Кодов 1964: 449 – 450).
                    </p>
                    <p>
                        <strong>Съвременни издания. </strong>За пръв път оригиналната Втора
                        Харитонова
                        преправка е публикувана през 2013 г. Изданието е луксозно и съдържа
                        фототипия на
                        Харитоновия автограф от Чирпан. Монографичното изследване е на Мила
                        Кръстева. То е
                        с превод на руски език от Атанаска Тошева и на английски език от Петя
                        Пейчева.
                        Преводите от черковнославянски език на съвременен български език са на
                        Антоанета
                        Джельова. Книгата е издадена от „Жанет 45" в Пловдив.
                    </p>
                    <p align="right">Автор: доц. д-р Мила Кръстева</p>
                    <p lang="en-US">Пловдив, 20.05.2017</p>
                </main>
            </div>
        </MainLayout>
    )
}

HaritonovaPrepravka2View.propTypes = {
    
}

export default HaritonovaPrepravka2View



// WEBPACK FOOTER //
// ./src/views/HaritonovaPrepravka2/index.js